import { render, staticRenderFns } from "./OfficerDashboard.vue?vue&type=template&id=06f71f26&scoped=true&"
import script from "./OfficerDashboard.vue?vue&type=script&lang=js&"
export * from "./OfficerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f71f26",
  null
  
)

export default component.exports